import { t } from "i18next";
import LabeledField from "providers/labeledField";
import { useEffect, useState } from "react";
import GenericCard from "widgets/cards/generic";
import { Alert } from "api/types/alerts";
import { deviceGet } from "api/device";
import { setLoading } from "store/appSlice";
import { useDispatch } from "react-redux";
import { Device } from "api/types/device";

interface GeneralProps {
  alert?: Alert;
  onUpdate?: () => void;
}

const DeviceInfo: React.FC<GeneralProps> = ({ alert, onUpdate }) => {
  const dispatch = useDispatch();
  const [device, setDevice] = useState<Device>(null);

  const fetchData = async () => {
    dispatch(setLoading(true));
    const { data, status, isLoading, error } = await deviceGet(alert?.snr);
    dispatch(setLoading(isLoading));
    if (!error && status && status === 200) {
      setDevice(data);
    }
  };

  useEffect(() => {
    if (alert?.snr && alert?.snr !== device?.snr) {
      fetchData();
    }
  }, [alert?.snr]);

  return (
    <>
      <GenericCard
        title={t("device.info.title")}
        bgColor="200"
        extraTitle="text-white heading-md h-fit"
      >
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("device.info.label.name")}
            id={"device-name"}
          >
            <div className="text-txt-lg text-white">
              {device?.name || t("device.info.placeholder.name")}
            </div>
          </LabeledField>
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("device.info.label.snr")}
            id={"device-snr"}
          >
            <div className="text-txt-lg text-white">
              {device?.snr || t("device.info.placeholder.snr")}
            </div>
          </LabeledField>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("device.info.label.address")}
            id={"device-address"}
          >
            <div className="text-txt-lg text-white">
              {device?.host || t("device.info.placeholder.address")}
            </div>
          </LabeledField>
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("device.info.label.model")}
            id={"device-model"}
          >
            <div className="text-txt-lg text-white">
              {device?.model || t("device.info.placeholder.model")}
            </div>
          </LabeledField>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("device.info.label.trigger.low")}
            id={"device-trigger-low"}
          >
            <div className="text-txt-lg text-white">
              {device?.triggerLow || t("device.info.placeholder.trigger.low")}
            </div>
          </LabeledField>
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("device.info.label.trigger.high")}
            id={"device-trigger-high"}
          >
            <div className="text-txt-lg text-white">
              {device?.triggerHigh || t("device.info.placeholder.trigger.high")}
            </div>
          </LabeledField>
        </div>
      </GenericCard>
    </>
  );
};

export default DeviceInfo;
